import { Text, Tooltip, Icon } from '@upsales/components';
import bemClass from '@upsales/components/Utils/bemClass';
import { useTranslation } from 'Components/Helpers/translate';
import colorMappings from '@upsales/components/Utils/colorMappings';
import { NOTETAKER_STATUS_VISUAL } from 'App/components/NotetakerStatusChip/NotetakerStatusChip';
import { hasSoftDeployAccess } from 'App/services/FeatureHelperStandalone';
import React from 'react';
import T from 'Components/Helpers/translate';

const ACTIVITY_TYPE_ICONS = {
	appointment: 'calendar',
	phonecall: 'phone',
	todo: 'activity'
};

export const CalendarItem = ({
	appointment,
	handleCalendarItemClick,
	invisible,
	continuousDate,
	startsBefore,
	fullDay,
	backgroundColor,
	onDragPointerDown,
	resizable
}) => {
	const { t } = useTranslation();
	const appointmentLength = (appointment.endDate.getTime() - appointment.date.getTime()) / (60 * 1000);

	const classes = new bemClass('Appointment');
	const textClassName = startsBefore && !fullDay ? 'transparent-text' : '';
	const wrapperStyle = invisible
		? { backgroundColor: 'transparent', margin: 0, padding: onDragPointerDown ? undefined : 0 }
		: continuousDate && startsBefore && !fullDay
		? { marginRight: -6, marginLeft: -6, paddingLeft: 10, borderRadius: 0 }
		: continuousDate
		? { marginRight: -6, borderTopRightRadius: 0, borderBottomRightRadius: 0 }
		: startsBefore && !fullDay
		? { marginLeft: -6, paddingLeft: 10, borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }
		: {};

	const textStyle = appointment.isEvent
		? { color: colorMappings.get('grey-10') }
		: appointment.color
		? { color: window.getTextColor(appointment.color) }
		: {};
	const clientName = appointment.client && appointment.client.name;
	const showClientName = appointmentLength > 25;
	const tooltip = appointment.isEditing
		? ''
		: appointment.description
		? `${appointment.description}${clientName ? '\n' + clientName : ''}`
		: t('calendar.event.private.tooltip');

	return (
		<div
			style={{ ...wrapperStyle, ...(backgroundColor && { backgroundColor }) }}
			className={classes
				.mod({
					clickable: !appointment.isEvent,
					editing: appointment.isEditing,
					draggable: !!onDragPointerDown,
					dragging: !!onDragPointerDown && !!appointment.isDragging
				})
				.b()}
			onClick={e => handleCalendarItemClick && handleCalendarItemClick(e, appointment)}
			onPointerDown={onDragPointerDown}
		>
			{!invisible && <div className={classes.elem('overlay').b()} />}
			<Tooltip title={tooltip} disabled={!tooltip}>
				<div className={classes.elem('header').b()}>
					{!appointment.isEvent ? (
						<Icon
							name={ACTIVITY_TYPE_ICONS[appointment.calendarItemType] || 'calendar'}
							style={textStyle}
							className="xs"
							spacing="mr2"
						/>
					) : null}
					{hasSoftDeployAccess('NOTETAKER_STATUS') &&
					appointment.notetakerStatus &&
					appointment.notetakerStatus.state ? (
						<Icon
							name={
								(
									NOTETAKER_STATUS_VISUAL[appointment.notetakerStatus.state] ||
									NOTETAKER_STATUS_VISUAL.wont_join
								).icon
							}
							style={textStyle}
							className="xs"
							spacing="mr2"
							title={T('appointment.notetakerStatus.' + appointment.notetakerStatus.state)}
						/>
					) : null}
					<Text bold style={textStyle} className={`xs time ${textClassName}`}>
						{startsBefore ? moment(startsBefore).format('HH:mm') : moment(appointment.date).format('HH:mm')}
					</Text>
					<Text
						bold
						style={textStyle}
						className={`noWrap ${textClassName} ${showClientName ? '' : 'xs'}`}
						size="sm"
					>
						{appointment.isEditing
							? appointment.description
							: appointment.description || t('default.occupied')}
					</Text>
				</div>
				{clientName && showClientName ? (
					<Text style={textStyle} className={`xs noWrap no-margin ${textClassName}`}>
						{clientName}
					</Text>
				) : null}
			</Tooltip>
			{onDragPointerDown && resizable ? (
				<div className={classes.elem('resize-handle').b()} data-resize-handle />
			) : null}
		</div>
	);
};
